import { Card, Col, Row, Spin } from "./../ui/ot";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom"
import AILogo from './AILogo'
import OTLogo from "./OTLogo";

const LineLogin = (props) => {
    const navigate = useNavigate()
    const date_now_time = Date.now()
    let [searchParams, setSearchParams] = useSearchParams()
    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const serviceOrNot = JSON.parse(state)?.hasOwnProperty('service')
    useEffect(() => {
        if (serviceOrNot) {
            let state_temp = JSON.parse(state).state;
            if (JSON.parse(state)?.need_rand) {
                state_temp = date_now_time
            }
            post_result({
                state: state_temp,
                service: JSON.parse(state).service,
                need_rand: JSON.parse(state)?.need_rand
            })
        } else {
            post_result({
                state
            })
        }
    }, [])
    const post_result = ({
        state,
        service,
    }) => {
        axios
            .post('/dgx',
                {
                    result_code: state,
                    result_data: JSON.stringify({
                        code: code
                    })
                }
            )
            .then(response => {
                if (service) {
                    if (service !== '/') {
                        get_line_login({
                            date_now: state,
                            service: service,
                        })
                    }
                    else {
                        window.close()
                    }
                }
            })
    }

    const get_line_login = ({
        date_now,
        service
    }) => {
        axios
            .get('/qrcode/login',
                {
                    params: {
                        result_code: date_now,
                        ...(JSON.parse(state)?.user_id ? { user_id: JSON.parse(state)?.user_id } : {})
                    }
                }
            )
            .then(response => {
                if (response.data?.refresh_token) {
                    if (service) {
                        localStorage.setItem("refresh_token", response.data.refresh_token)
                        localStorage.removeItem("access_token")
                        if (service.startsWith('http')) {
                            window.location.href = service
                        } else {
                            navigate(service);
                        }
                    }
                }
            })
    }
    return (
        <>
            <Row>
                <Col span={24}>
                    <div ></div>
                </Col>
            </Row>
            <Row justify="center"
                style={{ paddingTop: "150px" }}
            >
                <Col xs={16} sm={14} md={10} lg={12} xl={12}>
                    <Card>
                        <Row gutter={[32, 16]} justify="center" align='middle'>
                            {
                                props.logo === "OT" ?
                                    <Col >
                                        <img
                                            preview={false} src={OTLogo}
                                        >
                                        </img>
                                    </Col> :
                                    <Col span={8}>
                                        <img
                                            preview={false}
                                            src={AILogo}
                                        >
                                        </img>
                                    </Col>
                            }
                            {!serviceOrNot && <>
                                <Col span={24}>請確認回到瀏覽器，確認是否已登入</Col>
                                <Col span={24}>若無，請重新掃描QRCode</Col>
                            </>}
                            {serviceOrNot &&
                                <Col span={24}><Spin />請稍後...</Col>
                            }
                        </Row>
                    </Card>
                </Col>
            </Row>
        </>

    );
};
export default LineLogin